import _extends from 'babel-runtime/helpers/extends';

import { downloadWithIframe } from '@/common/download';
import { getFileExtension } from '@com/utils/file';

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    text: {
      type: String,
      default: '下载'
    },
    config: Object
  },

  computed: {
    innerConfig: function innerConfig() {
      return _extends({}, this.$attrs, this.config);
    }
  },

  methods: {
    download: function download() {
      // 是否下载 zip 包， 当 URL 包含 ,符号，或者文件后缀是 fbx/glb/gltf， 则代表需要下载 zip 包
      var isDownladZip = function isDownladZip(url) {
        return url.indexOf(',') > -1 || getFileExtension(url).toLocaleLowerCase() === 'fbx' || getFileExtension(url).toLocaleLowerCase() === 'gltf' || getFileExtension(url).toLocaleLowerCase() === 'glb';
      };
      var isZip = isDownladZip(this.url);
      if (this.url) {
        if (this.name) {
          downloadWithIframe(this.url, this.name, false, isZip);
        } else {
          downloadWithIframe(this.url, '', false, isZip);
        }
      } else {
        this.$emit('download');
      }
    }
  }
};